export default "__VITE_ASSET__9d9f9969__"